import React from 'react'
import ReactDOM from 'react-dom/client'
import { LanguageProvider } from './i18n/LanguageContext'
import App from './App.jsx'
import './index.css'
// Last import wins specificity ties against the per-component stylesheets.
import './mobile.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <LanguageProvider>
      <App />
    </LanguageProvider>
  </React.StrictMode>,
)
